module.exports = __webpack_public_path__ + "static/media/water-delivery-DMA.01e45513.jpg";